var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.unit.control_code == 'code')?_c('u-code'):(_vm.unit.control_code == 'link_area')?_c('u-link-area'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }